<div class="header">
  <div class="action">
    <div class="close" (click)="close(GeneralConfirmationModalResult.Cancel)">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ data.title }}</h3>
</div>
<div class="modal-body">
  @if (data.message) {
    <p class="center">{{ data.message }}</p>
  }
  <div class="input-container">
    <input type="text" class="input" [(ngModel)]="code" inputmode="numeric" autocomplete="one-time-code"/>
  </div>
  <div class="resend">
    <button class="button link" (click)="resendCode()" [disabled]="resending || resendCooldown > 0">
      @if (resendCooldown > 0) {
        {{ 'account-attribute-change-modal.resend-cooldown' | translate: { seconds: resendCooldown } }}
      } @else {
        {{ 'account-attribute-change-modal.resend-button' | translate }}
      }
    </button>
    @if (resendError) {
      <p class="resend-error">{{ 'account-attribute-change-modal.resend-error' | translate }}</p>
    }
  </div>
</div>
<div class="modal-footer">
  <button (click)="close(GeneralConfirmationModalResult.Cancel)"
    class="button secondary">{{ 'account-attribute-change-modal.cancel-button' | translate }}
  </button>
  <button (click)="confirm()"
    class="button primary">{{ 'account-attribute-change-modal.confirm-button' | translate }}
  </button>
</div>
